module.exports = __webpack_public_path__ + "default.png?c5d355197980acbf8d1c235549852a29";